enum AuthenticationFlowTypeEnum {
  Main = 'M',
  Proposal = 'P',
}

export default AuthenticationFlowTypeEnum
